export enum FormInputErrorEnum {
    RequiredField,
    ValidationError
}

export interface Suggestion {
    id: number;
    name: string;
}

export interface FormInputProps {
    value: string | number | undefined;
    label: string;
    name: string;
    inputError?: FormInputErrorEnum;
    valueSetter: (e: any) => void;
    required: boolean;
    type: 'text' | 'password' | 'number';
    helper?: string;
    className?: string;
    disabled?: boolean;
}


export interface SuggestionFormInputProps extends FormInputProps {
    fetchSuggestion: (value: string) => Promise<Suggestion[]>
}